import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const navItem = (to, label) => (
    <Link
      to={to}
      onClick={() => setOpen(false)}
      className={`block py-2 px-3 rounded-md text-white hover:text-gray-300
        ${location.pathname === to ? "text-yellow-300 font-semibold" : ""}`}
    >
      {label}
    </Link>
  );

  return (
    <nav className="bg-black w-full z-50 shadow-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3">

        {/* LOGO */}
        <Link to="/" className="text-white text-xl font-bold">
          MerinaSoft
        </Link>

        {/* Mobile Button */}
        <button
          className="text-white md:hidden text-3xl"
          onClick={() => setOpen(!open)}
        >
          {open ? <HiX /> : <HiMenu />}
        </button>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8">
          {navItem("/", "Home")}
          {navItem("/about", "About")}
          {navItem("/products", "Products")}
          {navItem("/services", "Services")}
          {navItem("/gallery", "Gallery")}
          {navItem("/contact", "Contact")}
        </div>
      </div>

      {/* Mobile Dropdown */}
      {open && (
        <div className="md:hidden px-4 pb-4 space-y-2 bg-black">
          {navItem("/", "Home")}
          {navItem("/about", "About")}
          {navItem("/products", "Products")}
          {navItem("/services", "Services")}
          {navItem("/gallery", "Gallery")}
          {navItem("/contact", "Contact")}
        </div>
      )}
    </nav>
  );
}
